import { render, staticRenderFns } from "./pi-add-report-file.vue?vue&type=template&id=ad8dd5d4"
import script from "./pi-add-report-file.vue?vue&type=script&lang=ts"
export * from "./pi-add-report-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports